import { Select } from "antd";
import React from "react";

const { Option } = Select;

export const DropdownLabel = ({
  label,
  options,
  width = "150px",
  fontSize = "14px",
  object_key,
  selected,
  customClassName,
  placeholder,
  ...rest
}) => {
  const labelLines = label?.split("\n")?.length;
  const labelHeight = 30 * labelLines;
  return (
    <div
      style={{
        display: "flex",
        // justifyContent: "space-between",
        // flexDirection: "column",
        alignItems: "center",
        fontSize: fontSize,
      }}
      className="fw-bold"
    >
      {label && (
        <div
          style={{
            padding: "2px 6px",
            height: labelHeight,
            display: "flex",
            alignItems: "center",
          }}
          {...rest}
        >
          {label}
        </div>
      )}
      <Select
        size="medium"
        placeholder={placeholder}
        style={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          height: `${labelHeight}px`,
          minWidth: "150px",
          fontSize: fontSize,
          borderRadius: 0,
          borderLeft: 0,
          width: width,
        }}
        className={customClassName}
        {...rest}
      >
        {options?.map((option, index) => {
          if (object_key == "customer") {
            return (
              <Option key={index} value={selected} className="bg-info">
                {`${index} - ${option["first_name"]} ${option["last_name"]}`}
              </Option>
            );
          } else if (object_key == "vendor") {
            return (
              <Option key={index} value={selected}>
                {`${option["id"]} - ${option["first_name"]} ${option["last_name"]}`}
              </Option>
            );
          } else if (object_key == "sku") {
            return (
              <Option key={index} value={option}>
                {option}
              </Option>
            );
          } else if (object_key == "rates") {
            return (
              <Option key={index} value={selected}>
                {`$${option?.price} ${option["serviceName"]} - ${option["packagingType"]}`}
              </Option>
            );
          } else {
            return (
              <Option key={index} value={selected}>
                {option}
              </Option>
            );
          }
        })}
      </Select>
    </div>
  );
};
